import { Box, Button, IconTrash, Typography } from '@screentone/core';

// import { EntityType } from 'contexts/datamodel/DataModelContext';
import { ArticleItem, NewsletterDto, PublicationSetting } from 'data/generated/graphql';
import { AllessehContent } from 'hooks/useAllessehContentQuery';
import { formatInTimeZone } from 'utils/dates';
import { safelyParseContent } from 'utils/temp';

export const NewsletterSettings = ({
  campaign,
  readOnly,
  isScheduled,
  cancelCampaign,
  publicationSetting
}: {
  readOnly: boolean | undefined;
  campaign?: NewsletterDto;
  isScheduled: boolean;
  cancelCampaign?: () => void;
  publicationSetting?: PublicationSetting;
}) => {
  if (!campaign) return null;

  const articleItem = campaign.root.collection[0]?.collection[0] as ArticleItem;
  const content: AllessehContent = safelyParseContent(articleItem);
  // Fallback to createdUtc timestamp if others are not available
  const defaultUtc = campaign.metadata.createdUtc;
  // updateUtc was used as published timestamp given that it was the only available timestamp in Allesseh.
  // In dynamo publishUtc is saved when the newsletter is sent or after the schedule is triggered
  const distributionSchedule = campaign.metadata.publishUtc ?? campaign.metadata.updatedUtc ?? defaultUtc;

  // Finds the first available article in the first available module
  // const articleItem = campaign.root.collection.find((module) =>
  //   module.collection.find((item) => item.type === EntityType.Article)
  // ) as ArticleItem;

  return (
    <>
      {readOnly && (
        <>
          <Box margin={{ bottom: 'md' }}>
            <Box.Title data-testid="newsletters-setting-title">Distribution Schedule</Box.Title>
            <Box.Content>
              <Typography
                variant="header4"
                margin={{ bottom: 'sm' }}
                data-testid="newsletters-setting-scheduled-timezone"
              >
                {formatInTimeZone(distributionSchedule, publicationSetting?.preferredTimezone, 'MMMM dd, yyyy', {
                  showTimezoneAbbreviation: false
                })}{' '}
                at{' '}
                {formatInTimeZone(distributionSchedule, publicationSetting?.preferredTimezone, 'h:mm aaaa', {
                  showTimezoneAbbreviation: true
                })}
              </Typography>
              <Typography data-testid="newsletter-setting-headline">
                {content.data.attributes.headline?.text}
              </Typography>
              {isScheduled && cancelCampaign && (
                <Button
                  data-testid="newsletters-setting-cancel-campaign"
                  tertiary
                  margin={{ top: 'sm' }}
                  icon={IconTrash}
                  color="lava"
                  onClick={cancelCampaign}
                >
                  Cancel Campaign
                </Button>
              )}
            </Box.Content>
          </Box>
        </>
      )}
    </>
  );
};
